import React from 'react';
import c from 'classnames';

import { Container, Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

export interface HeroBuurtboerderijProps {
  title: string;
  subtitle?: string;
  body?: string;
  image?: string;
  className?: string;
  children?: React.ReactNode | undefined;
  small?: boolean;
}

const HeroBuurtboerderij: React.FC<HeroBuurtboerderijProps> = (props) => {
  const {
    title,
    subtitle,
    body,
    image,
    className,
    children,
    small = false,
  } = props;

  const classNames = c('HeroBuurtboerderij', className, {
    'HeroBuurtboerderij--with-children': children,
  });

  const colClassNames = c('col-12 col-md-10 offset-md-1', {
    'col-lg-6 offset-lg-3': small,
    'col-lg-8 offset-lg-2': !small,
  });

  return (
    <div className={classNames}>
      {image && (
        <div className="HeroBuurtboerderij__image">
          <Image
            lazyload
            // @ts-expect-error
            includeWebP
            src={image}
          />
        </div>
      )}

      <Container>
        <div className="row">
          <div className={colClassNames}>
            <div className="HeroBuurtboerderij__content">
              <h1 className="HeroBuurtboerderij__title order-2">
                {title}
              </h1>

              {subtitle && (
                <h2 className="HeroBuurtboerderij__subtitle asH3 order-1">
                  {subtitle}
                </h2>
              )}

              {body && (
                <WysiwygField
                  className="HeroBuurtboerderij__body order-3"
                  property="schema:text"
                  html={body}
                />
              )}

              {children && (
                <div className="HeroBuurtboerderij__children order-4">
                  {children}
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HeroBuurtboerderij;
